import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-4" }
const _hoisted_2 = { class: "text-base sm:text-lg font-bold text-brown flex items-center gap-2" }
const _hoisted_3 = { class: "text-xs text-alternative-gray mt-0.5" }
const _hoisted_4 = { class: "p-4 rounded-xl bg-beige border border-divider space-y-2" }
const _hoisted_5 = { class: "text-[11px] font-bold uppercase tracking-wider text-active" }
const _hoisted_6 = { class: "text-base font-bold text-brown font-caudex" }
const _hoisted_7 = { class: "text-xs text-alternative-gray space-y-1 pt-1" }
const _hoisted_8 = { class: "text-brown" }
const _hoisted_9 = { class: "text-brown" }
const _hoisted_10 = { class: "p-4 rounded-xl bg-secondary border border-divider space-y-3" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-xs font-bold uppercase tracking-wide text-brown" }
const _hoisted_13 = { class: "space-y-2 text-xs" }
const _hoisted_14 = { class: "flex justify-between py-1 border-b border-divider" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "font-bold text-brown" }
const _hoisted_17 = { class: "flex justify-between py-1 border-b border-divider" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "font-bold text-brown" }
const _hoisted_20 = { class: "flex justify-between py-1 border-b border-divider" }
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = { class: "font-bold text-brown" }


import { useI18n } from "vue-i18n";
import { BodyAndStem } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyHealthTaboosComponent',
  props: {
    bodyAndStem: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.title")), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-xs font-normal text-muted font-caudex" }, " (人神彭祖) ", -1))
      ]),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.subtitle")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.pengZuCanon")), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.bodyAndStem.peng_zu_bai_ji.combined_text), 1),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" •", -1)),
          _createElementVNode("strong", _hoisted_8, _toDisplayString(__props.bodyAndStem.peng_zu_bai_ji.stem_taboo.clause), 1),
          _createTextVNode(" " + _toDisplayString(__props.bodyAndStem.peng_zu_bai_ji.stem_taboo.ua), 1)
        ]),
        _createElementVNode("li", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" •", -1)),
          _createElementVNode("strong", _hoisted_9, _toDisplayString(__props.bodyAndStem.peng_zu_bai_ji.branch_taboo.clause), 1),
          _createTextVNode(" " + _toDisplayString(__props.bodyAndStem.peng_zu_bai_ji.branch_taboo.ua), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.humanSpirit")), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.byLunarDay", {
                day: __props.bodyAndStem.human_spirit_locations.lunar_day.day_number,
              })), 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(__props.bodyAndStem.human_spirit_locations.lunar_day.part_cn) + " (" + _toDisplayString(__props.bodyAndStem.human_spirit_locations.lunar_day.part_ua) + ") ", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.byStem", {
                stem: __props.bodyAndStem.human_spirit_locations.day_stem.stem,
              })), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(__props.bodyAndStem.human_spirit_locations.day_stem.part_cn) + " (" + _toDisplayString(__props.bodyAndStem.human_spirit_locations.day_stem.part_ua) + ") ", 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.health.byBranch", {
                branch: __props.bodyAndStem.human_spirit_locations.day_branch.branch,
              })), 1),
          _createElementVNode("span", _hoisted_22, _toDisplayString(__props.bodyAndStem.human_spirit_locations.day_branch.part_cn) + " (" + _toDisplayString(__props.bodyAndStem.human_spirit_locations.day_branch.part_ua) + ") ", 1)
        ])
      ])
    ])
  ]))
}
}

})